(ns app.front.view.group.admin.inspections.template-selector
  "An inspection template selector operating on a configuration branch."
  (:require [app.domain.inspection.model :as inspection-model]
            [app.front.ui :as ui]
            [app.front.ui.select :as ui-select]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.config-selectors :as conf-sel]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.inspections.subs :as inspection-sub]
            [app.front.view.inspections.util :as inspection-util]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub]]
            [core.front.feature-flags :as ff]
            [re-frame.core-instrumented :as rf]))

;;; rf
;;;;;;
(rf/reg-sub ::selectable-inspection-kinds
  :<- [::gas/template-kind-entities]
  :<- [::ff/enabled? :feature-flag.id/pre-issuance-inspections]
  (fn [[template-kinds pre-issuance-inspections?] [_ attr]]
    (cond->> (inspection-sub/handle-selectable-inspection-kinds template-kinds nil)
      pre-issuance-inspections? (filter (partial inspection-model/inspection-template-kind-applicable-to-config-attr? attr)))))

(defn template-kind-pairs-for-one [template-kind]
  (->> template-kind
       :entity/_parent
       (map (fn [t] [(:db/id t) (:db/id template-kind)]))))

(rf/reg-sub ::template->kind
  :<- [::gas/template-kind-entities]
  (fn [kinds _]
    (->> (inspection-sub/handle-selectable-inspection-kinds kinds nil)
         (mapcat template-kind-pairs-for-one)
         (into {}))))

;;; util
;;;;;;;;

(defn inspection-kind-ids [template->kind templates]
  (->> templates
       (map template->kind)
       set))

(defn- change-selected-template-fn [*group-config attr old-template-id]
  (fn [{new-template-id :db/id}]
    (swap! *group-config
           (fn [cfg]
             (-> cfg
                 (update attr disj old-template-id)
                 (update attr conj new-template-id))))))

;;; view
;;;;;;;;

(defn inspection-template-selector-base
  "Checkboxes for inspection-kinds, but underlying value is inspection-template. Nil if inspections
  not enabled/available."
  [attr {:keys [tr *group-config parent-config] :as ctx}]
  (let [template->kind            (<sub [::template->kind])
        pre-issuance-inspections? (<sub [::ff/enabled? :feature-flag.id/pre-issuance-inspections])
        parent-opts               (->> parent-config
                                       attr
                                       keys
                                       set)
        inspection-templates      (attr @*group-config)
        current-opts              (inspection-kind-ids template->kind inspection-templates)
        val->str                  (partial inspection-util/template->string tr)
        inspection-kinds          (<sub [::selectable-inspection-kinds attr])
        lang                      (<sub [:language])]
    (cond
      (seq inspection-kinds)
      [acommon/form-group
       {:legend-text (tr [:group.config/inspection-templates])}
       (for [{kind-id :db/id
              :as     template-kind} inspection-kinds]
         (let [curr-sel-template-id             (->> inspection-templates
                                                     (filter #(= kind-id (template->kind %)))
                                                     first)
               templates                        (->> template-kind
                                                     inspection-model/get-templates-for-kind
                                                     (sort-by val->str))
               template-id                      (or curr-sel-template-id
                                                    (-> templates first :db/id))
               more-than-one-template-for-kind? (-> templates count (> 1))]
           [:div
            (cc/checkbox
              (assoc (conf-sel/checkbox-props ctx
                                              kind-id
                                              kind-id
                                              #(inspection-model/inspection-template-kind-name % lang)
                                              current-opts
                                              parent-opts
                                              attr
                                              template-kind)
                     :on-change #(swap! *group-config
                                        update
                                        attr
                                        (if % conj disj)
                                        template-id)))
            (when (and (current-opts kind-id)
                       more-than-one-template-for-kind?)
              [ui-select/select
               {:id           (str "template-of-kind" kind-id)
                :label-text   (tr [:inspection/select-inspection])
                :values       templates
                :allow-empty? false
                :on-change    (change-selected-template-fn *group-config attr template-id)
                :val->str     val->str
                :value        (->> templates
                                   (filter #(-> % :db/id (= template-id)))
                                   first)}])]))]

      pre-issuance-inspections?
      [acommon/form-group
       {:legend-text (tr [:group.config/inspection-templates])}
       [ui/help (tr [:group.config/no-inspection-templates])]])))

(def inspection-template-selector
  (partial inspection-template-selector-base :group.config/inspection-templates))

(def app-inspection-template-selector
  (partial inspection-template-selector-base :group.config/application-inspection-templates))
